import { TreeNodeModel } from '@creditsights/styleguide-web';
import { Filters, TagOptionParameters, TreeModelParameters } from '../models';
import { TagsFilterParams } from '../services/tags/tags.model';

export const convertToTreeModel = ({ options, filter }: TreeModelParameters): TreeNodeModel[] => {
  const filteredOptions = filter ? options.filter(filter) : options;
  return filteredOptions.map((option) =>
    convertTagOption({
      option,
      filter,
    })
  );
};

const MAX_CONVERT_TAG_DEPTH = 2;

const convertTagOption = ({ option, filter, currentDepth = 1 }: TagOptionParameters): TreeNodeModel => {
  const filteredChildren = filter ? option.children?.filter(filter) : option.children;
  return {
    key: option.tagId,
    title: option.displayName,
    children:
      currentDepth < MAX_CONVERT_TAG_DEPTH
        ? filteredChildren?.map((child) =>
            convertTagOption({
              option: child,
              filter,
              currentDepth: currentDepth + 1,
            })
          )
        : undefined,
  };
};

/**
 * Returns filters in a format ready to call API
 * Filters are grouped to support AND/OR logic.
 * For example passing: `{ tags: "source": ["type-tag/news"], "region": ["region/europe", "region/america"]}`
 * would return `[["type-tag/news"], ["region/europe", "region/america"]]`
 * which would logically translate to: "news" AND ("europe" or "america")
 */
export const getGroupedFilterTags = (filters: Filters | null): TagsFilterParams => {
  if (!filters?.tags) {
    return [];
  }

  return Object.values(filters.tags);
};

export const getTitleContainsFilter = (title: string | undefined): string | undefined => {
  return title ? `content.title:"${title}"` : undefined;
};
